import ko from 'knockout';
import Vue from 'vue';
import vuetify from '../../../plugins/vuetify';
import UserDetailsService from './user-details.service';
import UserDetails from './userDetails.vue';
import template from 'raw-loader!./user-details-view.html';

class UserDetailsView {
  constructor(params) {
    let self = this;
    self.route = params.route;
    self.initVue();
    self.subscriptions = [
      self.route.subscribe(function() {
        if (self.vueUserDetails) {
          self.vueUserDetails.route = self.route();
        }
      })
    ];
  }

  dispose() {
    let self = this;
    for (let i=0, _i=self.subscriptions.length; i<_i; i++) {
      self.subscriptions[i].dispose();
    }
    if (self.vueUserDetails) {
      self.vueUserDetails.$destroy();
      self.vueUserDetails.$el.parentNode.removeChild(self.vueUserDetails.$el);
    }

  }

  initVue() {
    let self = this,
        route = self.route();

    if (!route.startDate && !route.endDate) {
      let defaultDateRange = UserDetailsService.getDefaultDateRange();
      route.startDate = defaultDateRange.startDate;
      route.endDate = defaultDateRange.endDate;
    }

    self.vueUserDetails = new Vue({
      el: '#vueUserDetails',
      vuetify,
      components: {
        'user-details': UserDetails
      },
      data: function() {
        return {
          route
        };
      }
    });
  }
}

export default UserDetailsView;

ko.components.register('historical2-user-details-view', { template: template, viewModel: UserDetailsView });
